import type { ElementType } from 'react';

interface RevealLinesProps {
  lines: string[];
  as?: ElementType;
  className?: string;
  lineClassName?: string;
}

export default function RevealLines({ lines, as: Tag = 'h2', className = '', lineClassName = '' }: RevealLinesProps) {
  return (
    <Tag className={className} data-reveal="lines">
      {lines.map((line) => (
        <span key={line} className="line-mask">
          <span className={`line-inner ${lineClassName}`}>{line}</span>
        </span>
      ))}
    </Tag>
  );
}